import { getAnalytics } from 'firebase/analytics';
import { getAuth } from 'firebase/auth';
import { getFirestore } from 'firebase/firestore';
import {
  firebaseConfig,
  getOrInitFirebaseApp,
  initAppCheck,
} from '../app/firebase.config';

const app = getOrInitFirebaseApp();
initAppCheck(app);

const analytics = typeof window !== 'undefined' ? getAnalytics(app) : ({} as ReturnType<typeof getAnalytics>);
const auth = getAuth(app);
const firestore = getFirestore(app);

export const environment = {
  production: false,
  firebaseConfig,
  app,
  analytics,
  auth,
  firestore,
};
